import React from 'react'

const RegistrationPopup = () => {
  return (
    <div className='w-100'>
      <iframe
        src="https://forms.zohopublic.com/almotahidaeducation1/form/CourseApplication/formperma/eBx0tn1OcB-GQukt2Ia47chNZA8pWKuvAEpX1f1VGrg"
        width={"100%"}
     style={{ height:"80vh" }}

      />
    </div>
  )
}

export default RegistrationPopup

// import React, { useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Col, Row, Button, Form, Alert } from 'react-bootstrap';
// import { toast } from 'react-toastify';

// const RegistrationPopup = ({setIsModalOpen}) => {
//   const { t } = useTranslation();

//   const [validated, setValidated] = useState(false);
//   const [result, setResult] = useState({ type: '', msg: '' });
//   const [showFallback, setShowFallback] = useState(false);

//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     city: '',
//     country: '',
//     program: '',
//     subject: '',
//     message: '',
//   });

//   // Refs for fallback copy
//   const subjectRef = useRef(null);
//   const bodyRef = useRef(null);

//   const handleChange = (e) => {
//     setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));
//   };

//   // Safely encode for use inside mailto
//   const enc = (str) => encodeURIComponent(str || '');

//   // Build email body with CRLF for Outlook/Windows compatibility
//   const buildEmailPieces = () => {
//     const name = `${formData.firstName.trim()} ${formData.lastName.trim()}`.trim();
//     const bodyLines = [
//       `Name: ${name}`,
//       `Email: ${formData.email.trim()}`,
//       `Program: ${formData.program || '-'}`,
//       `Subject: ${formData.subject.trim()}`,
//       '',
//       'Message:',
//       formData.message.trim(),
//       '',
//       '--- Extra Info ---',
//       `Phone: ${formData.phone || '-'}`,
//       `City: ${formData.city || '-'}`,
//       `Country: ${formData.country || '-'}`,
//     ];
//     const bodyCRLF = bodyLines.join('\r\n');
//     const subject = formData.subject.trim() || 'Inquiry';
//     const mailtoHref = `mailto:admission@kalemon.academy?subject=${enc(subject)}&body=${enc(bodyCRLF)}`;
//     return { subject, bodyCRLF, mailtoHref };
//   };

//   const openMailto = (mailtoHref) => {
//     try {
//       const a = document.createElement('a');
//       a.setAttribute('href', mailtoHref);
//       a.style.display = 'none';
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       return true;
//     } catch {
//       return false;
//     }
//   };
//     const successNotify = (msg) => {
//       toast.success(
//         <div className="d-flex justify-content-around align-items-center">
//           <h6 style={{ fontFamily: "Hacen Algeria" }}>{msg}</h6>
//         </div>,
//         {
//           position: "top-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: false,
//           draggable: true,
//           progress: undefined,
//         }
//       );
//     };
//   const handleSubmit = (event) => {
//     event.preventDefault();
//     const form = event.currentTarget;

//     // Trigger native validation
//     if (!form.checkValidity()) {
//       event.stopPropagation();
//       setValidated(true);
//       return;
//     }

//     const { subject, bodyCRLF, mailtoHref } = buildEmailPieces();

//     // Guard for long URLs (some clients choke around ~2k chars)
//     if (mailtoHref.length > 1900) {
//       setShowFallback(true);
//       setResult({
//         type: 'warning',
//         msg: t('contactUs.long_body_warning', 'Your message is quite long. Please copy the details below and send manually.'),
//       });
//       return;
//     }

//     // Try to open mail client
//     const ok = openMailto(mailtoHref);

//     if (ok) {
//       setResult({
//         type: 'success',
//         msg: t('contactUs.opening_mail_app', 'Opening your email app… If nothing happens, please check your default mail client settings.'),
//       });
//       // Close the modal on the next tick to preserve the user gesture chain
//       successNotify('Message sent successfully!');
//       setTimeout(() => setIsModalOpen(false), 0);
//     } else {
//       // Show fallback UI with prefilled subject/body for manual copy
//       setShowFallback(true);
//       setResult({
//         type: 'danger',
//         msg: t('contactUs.mailto_failed', 'Could not open your email client. Please copy the details below and send manually.'),
//       });
//       // Ensure refs are populated on next paint
//       setTimeout(() => {
//         if (subjectRef.current) subjectRef.current.value = subject;
//         if (bodyRef.current) bodyRef.current.value = bodyCRLF;
//       }, 0);
//     }
//   };

//   // Copy helper
//   const copyText = async (targetRef) => {
//     const el = targetRef.current;
//     if (!el) return;
//     try {
//       // Prefer modern clipboard API
//       if (navigator.clipboard && window.isSecureContext) {
//         await navigator.clipboard.writeText(el.value);
//       } else {
//         // Fallback: select & execCommand
//         el.focus();
//         el.select();
//         document.execCommand('copy');
//       }
//       setResult({ type: 'success', msg: t('contactUs.copied', 'Copied!') });
//     } catch {
//       setResult({ type: 'danger', msg: t('contactUs.copy_failed', 'Copy failed. Please select and copy manually.') });
//     }
//   };

//   const { subject, bodyCRLF } = buildEmailPieces();

//   return (
//     <div className="form-container ">
//       <div className="form-header mb-3">
//         <h2>{t('contactUs.title')}</h2>
//       </div>

//       <div className="form-body">
//         {result.msg && (
//           <Alert variant={result.type} className="mb-3">
//             {result.msg}
//           </Alert>
//         )}

//         <Form noValidate validated={validated} onSubmit={handleSubmit}>
//           <Row className="mb-3">
//             <Form.Group as={Col} md="6" controlId="firstName">
//               <Form.Label>{t('contactUs.firstName')}</Form.Label>
//               <Form.Control
//                 required
//                 type="text"
//                 name="firstName"
//                 value={formData.firstName}
//                 onChange={handleChange}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {t(' First name is required')}
//               </Form.Control.Feedback>
//             </Form.Group>

//             <Form.Group as={Col} md="6" controlId="lastName">
//               <Form.Label>{t('contactUs.lastName')}</Form.Label>
//               <Form.Control
//                 required
//                 type="text"
//                 name="lastName"
//                 value={formData.lastName}
//                 onChange={handleChange}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {t(' Last name is required')}
//               </Form.Control.Feedback>
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12" controlId="email">
//               <Form.Label>{t('contactUs.email')}</Form.Label>
//               <Form.Control
//                 required
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {t( 'Valid email is required')}
//               </Form.Control.Feedback>
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12" controlId="phone">
//               <Form.Label>{t('contactUs.phone')}</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="phone"
//                 placeholder="+2 010 123 4567"
//                 value={formData.phone}
//                 onChange={handleChange}
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="6" controlId="city">
//               <Form.Label>{t('contactUs.city')}</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="city"
//                 value={formData.city}
//                 onChange={handleChange}
//               />
//             </Form.Group>
//             <Form.Group as={Col} md="6" controlId="country">
//               <Form.Label>{t('contactUs.country')}</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="country"
//                 value={formData.country}
//                 onChange={handleChange}
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12" controlId="program">
//               <Form.Label>{t('contactUs.program')}</Form.Label>
//               <Form.Select
//                 required
//                 name="program"
//                 value={formData.program}
//                 onChange={handleChange}
//               >
//                 <option value="">{t('contactUs.program_placeholder')}</option>
//                 <option value="KalemonK12">Kalemon K-12</option>
//                 <option value="Arabic-for-Life">Arabic for Life</option>
//                 <option value="Specialized-Arabic">Specialized Arabic</option>
//                 <option value="Arabic-Calligraphy">Arabic Calligraphy</option>
//                 <option value="Kalemon-Levels">Kalemon Levels</option>
//                 <option value="Conversation-Programs">Conversation Programs</option>
//                 <option value="Teacher-Training-Diploma">Teacher Training Diploma</option>
//               </Form.Select>
//               <Form.Control.Feedback type="invalid">
//                 {t( 'Program is required')}
//               </Form.Control.Feedback>
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12" controlId="subject">
//               <Form.Label>{t('contactUs.subject')}</Form.Label>
//               <Form.Control
//                 required
//                 type="text"
//                 name="subject"
//                 value={formData.subject}
//                 onChange={handleChange}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {t( 'Subject is required')}
//               </Form.Control.Feedback>
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12" controlId="message">
//               <Form.Label>{t('contactUs.message')}</Form.Label>
//               <Form.Control
//                 required
//                 as="textarea"
//                 rows={4}
//                 name="message"
//                 placeholder={t('contactUs.message_placeholder')}
//                 value={formData.message}
//                 onChange={handleChange}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {t('Message is required')}
//               </Form.Control.Feedback>
//             </Form.Group>
//           </Row>

//           <div className="submit-section d-flex justify-content-between align-items-start">
//             <Button type="submit" className="mx-4">
//               {t('contactUs.send')}
//             </Button>
//             <p className="form-text">{t('contactUs.privacy_notice')}</p>
//           </div>
//         </Form>
//       </div>
//     </div>
//   );
// };

// export default RegistrationPopup;


